export const fmtCurrency = (value) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value ?? 0);
export const fmtDate = (value) => (value ? new Date(value).toLocaleDateString('de-DE') : '—');

export function formatDays(days) {
    if (days == null) return '—';
    if (days < 0) {
        return `${Math.abs(days)} Tage bis Fälligkeit`;
    }
    if (days === 0) {
        return 'Heute fällig';
    }
    return `${days} Tage überfällig`;
}

export function buildCsvRow(values) {
    return values
        .map((value) => {
            if (value == null) {
                return '';
            }
            const text = String(value).replace(/"/g, '""');
            if (text.search(/[";\n]/) >= 0) {
                return `"${text}"`;
            }
            return text;
        })
        .join(';');
}

export function downloadCsv(rows, filename) {
    const blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
